import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from '../Icon'

const SArrow = styled.span`
  position: absolute;
  display: flex;
  z-index: 20;
  padding: 10px;
  cursor: pointer;
  left: ${(props) => (props.$direction === 'back' ? '0' : 'auto')};
  right: ${(props) => (props.$direction === 'next' ? '0' : 'auto')};
  background: rgba(255, 255, 255, 0.3);

  &:hover {
    background: rgba(255, 255, 255, 1);
  }
`

const Arrow = ({ direction, onClick }) => {
  return (
    <SArrow $direction={direction} onClick={onClick}>
      <Icon size={24} name={direction} strokeColor="primary" />
    </SArrow>
  )
}

Arrow.propTypes = {
  direction: PropTypes.oneOf(['next', 'back']),
}

export default Arrow
